import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "@/features/auth/AuthContext";
import { router } from "./router";
import "./styles/global.css";

// Warm the API origin (DNS+TLS) before the first fetch. The origin is only
// known via VITE_API_URL, so this can't live statically in index.html.
const apiUrl = import.meta.env.VITE_API_URL as string | undefined;
if (apiUrl?.startsWith("https://")) {
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = new URL(apiUrl).origin;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);
